import React, { useState, useRef } from "react"
import concatWithSpaces from "../Functions/concatWithSpaces"
import DropdownButton from "./DropdownButton"
import HyperDiv from "./HyperDiv/HyperDiv"
import MouseOverableFullyExpandedContainer from "./MouseOverableFullyExpandedContainer"

interface Props extends React.ComponentProps<"div"> {
	Options?: React.ReactNode
	isSelected?: boolean
	optionButtons?: boolean
}

const DropdownOptionButton = ({
	Options,
	isSelected,
	optionButtons,
	onClick = () => {},
	onMouseEnter = () => {},
	onMouseLeave = () => {},
	style,
	children,
	...props
}: Props) => {
	const [showOptions, setShowOptions] = useState(false)
	const [isHoveredBtn, setIsHoveredBtn] = useState(false)
	const btnRef = useRef<HTMLDivElement>(null)
	const optsRef = useRef<HTMLDivElement>(null)

	const getBtnWidth = () => {
		return btnRef.current?.offsetWidth ?? 0
	}

	const _onClick = (e: any) => {
		setShowOptions((bool) => !bool)
		onClick(e)
	}

	const _onMouseEnter = (e: any) => {
		onMouseEnter(e)
		setIsHoveredBtn(true)
	}
	const _onMouseLeave = (e: any) => {
		onMouseLeave(e)
		setIsHoveredBtn(false)
	}
	return (
		<>
			<MouseOverableFullyExpandedContainer
				onChangeHover={(hovered: any) => !hovered && setShowOptions(false)}
				style={{ zIndex: 50 }}
			>
				<DropdownButton
					{...props}
					style={{
						paddingLeft: "2.65em",
						paddingRight: "2.65em",
						...style,
					}}
					onClick={_onClick}
					onMouseEnter={_onMouseEnter}
					onMouseLeave={_onMouseLeave}
					ref={btnRef}
					isSelected={isSelected}
				>
					<HyperDiv centered>{children}</HyperDiv>
				</DropdownButton>
				<div
					className={concatWithSpaces(
						"dropdown-base",
						"absolute",
						"fill-cter",
						showOptions ? "" : "abs-hidden"
					)}
					style={{
						position: "absolute",
						height: "min-content",
						width: getBtnWidth(),
						top: 30,
						zIndex: 20,
						borderRadius: 0,
						// Animation
						transition: ".1s var(--default-slide-transition-fn)",
						transitionProperty: "opacity",
					}}
					ref={optsRef}
				>
					{Options}
				</div>
			</MouseOverableFullyExpandedContainer>
		</>
	)
}

export default DropdownOptionButton
